// @flow

import authApiService from './auth-api-service';

import type { UserType } from '../types/user';
import type { AddressFormInput } from '../models/AddressForm';
import type { AddressType } from '../types/address';

type UserIncludeType = UserType & any;

export class UserService {
  show(include: string = ''): Promise<UserIncludeType> {
    return authApiService.get(`/user${include}`).then((response) => response.user);
  }

  create(newUser): Promise<UserType> {
    return authApiService.post('/users', { user: newUser })
      .then((response) => response.user);
  }

  createAddress(newAddress: AddressFormInput): Promise<AddressType> {
    return authApiService.put('/user', { user: {
      phone: newAddress.phone
    } }).then(() => authApiService.post('/addresses', { address: newAddress })).then((response) => response.address);
  }

  getAddress(): Promise<AddressType> {
    return authApiService.get('/address').then((response) => response.address);
  }

  updateAddress(newAddress: AddressFormInput): Promise<AddressType> {
    return authApiService.put('/user', { user: {
      phone: newAddress.phone
    } }).then(() => authApiService.put('/addresses', { address: newAddress })).then((response) => response.address);
  }

  edit(newUser): Promise<UserType> {
    return authApiService.put('/user', { user: newUser }).then((response) => response.user);
  }

  getEmailStatus(): Promise<UserType> {
    return authApiService.get('/email_verified').then((response) => response.user);
  }

  resendVerification(): Promise<UserType> {
    return authApiService.post('/email_verification_ticket').then((response) => response.user);
  }

  requestDownloadLink(phoneForm): Promise<UserType> {
    return authApiService.post('/twilio/app_download', {
      phone_form: phoneForm
    }).then((response) => response.user);
  }

  removeBanner(bannerName: string): Promise<UserType> {
    return authApiService
      .delete(`/user/banners?name=${bannerName}`)
      .then((response) => response.user);
  }
}

export default new UserService();



// WEBPACK FOOTER //
// ./src/services/user-service.js